export const ADD_ERROR = "ADD_ERROR";
export const REMOVE_ERROR = "REMOVE_ERROR";
export const LOAD_USER = "LOAD_USER";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOAD_CART = "LOAD_CART";
export const UPDATE_CART = "UPDATE_CART";
export const REMOVE_CART = "REMOVE_CART";
export const ADD_CART = "ADD_CART";
export const LOAD_CART_ITEM = "LOAD_CART_ITEM";
export const LOAD_PRODUCTS = "LOAD_PRODUCTS";
export const UPDATE_PRODUCTS = "UPDATE_PRODUCTS";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const LOAD_PRODUCT = "LOAD_PRODUCT";
export const LOAD_SUPPORT = "LOAD_SUPPORT";
export const UPDATE_SUPPORT = "UPDATE_SUPPORT";
export const LOAD_BUDGET = "LOAD_BUDGET";
export const LOAD_POPULAR = "LOAD_POPULAR";
export const LOAD_RECENT_VIEWED = "LOAD_RECENT_VIEWED";
export const LOAD_BROWSE = "LOAD_BROWSE";
export const ADD_ADDRESS = "ADD_ADDRESS";
export const LOAD_ADDRESS = "LOAD_ADDRESS";
export const UPDATE_ADDRESS = "UPDATE_ADDRESS";
export const LOAD_CATEGORIES = "LOAD_CATEGORIES";
export const REMOVE_CATEGORY = "REMOVE_CATEGORY";
export const LOAD_SUBCATEGORIES = "LOAD_SUBCATEGORIES";
export const REMOVE_SUBCATEGORY = "REMOVE_SUBCATEGORY";
export const LOAD_ORDERS = "LOAD_ORDERS";
export const UPDATE_SELLS = "UPDATE_SELLS";
export const LOAD_SELLS = "LOAD_SELLS";
export const LOAD_RATINGS = "LOAD_RATINGS";
export const REMOVE_RATING = "REMOVE_RATING";
export const LOAD_PAYOUTS = "LOAD_PAYOUTS";
export const LOAD_FAVORITES = "LOAD_FAVORITES";
export const REMOVE_FAVORITE = "REMOVE_FAVORITE";
export const LOAD_MESSAGES = "LOAD_MESSAGES";
export const ADD_MESSAGES = "ADD_MESSAGES";
export const LOAD_MESSAGE = "LOAD_MESSAGE";
export const LOAD_ROOMS = "LOAD_ROOMS";
export const LOAD_ROOM = "LOAD_ROOM";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const LOAD_VIEWS = "LOAD_VIEWS";
